import * as imported from "./addresses.json";
export const addresses = imported;
